import cx from 'classnames'

type Props = {
  progress: number
  isComplete: boolean
  model: string
  contentType: string
  onReset: () => void
}

const EvaluationProgress = ({
  progress,
  isComplete,
  model,
  contentType,
  onReset,
}: Props) => {
  return (
    <div className="bg-white border border-gold-200 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-sm font-semibold">
            {isComplete ? 'Evaluation complete' : 'Running evaluation'}
          </div>
          <div className="text-xs text-coolGray-400">
            {model} · {contentType}
          </div>
        </div>
        <div className="flex gap-2 items-center">
          {!isComplete && (
            <span className="flex items-center gap-1.5 text-xs text-coolGray-400">
              <svg
                className="w-3.5 h-3.5 animate-spin"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="3"
                  className="opacity-25"
                />
                <path
                  d="M4 12a8 8 0 018-8"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </svg>
              In progress
            </span>
          )}
          {isComplete && (
            <span className="flex items-center gap-1.5 text-xs font-semibold text-green-700">
              <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 12l2 2 4-4"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
              Complete
            </span>
          )}
          <button
            type="button"
            className="text-xs text-coolGray-400 hover:text-coolGray-600 px-2 py-1"
            onClick={onReset}
          >
            Reset
          </button>
        </div>
      </div>

      <div className="mt-3 h-0.5 bg-gold-100 rounded-full overflow-hidden">
        <div
          className={cx(
            'h-full rounded-full transition-all duration-700 ease-out',
            isComplete ? 'bg-green-500' : 'bg-yellow-400'
          )}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  )
}

export default EvaluationProgress
